exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/*! _variables 07/02/2018  // (C) IHG. All rights reserved. */.ngb-dp-week-number,.ngb-dp-weekday{line-height:2rem}.ngb-dp-weekday{color:#5bc0de}.ngb-dp-week{display:-ms-flexbox;display:flex}[dir] .ngb-dp-week{border-radius:.25rem}[dir] .ngb-dp-weekdays{border-bottom:1px solid rgba(0,0,0,.125);border-radius:0}.ngb-dp-day,.ngb-dp-week-number,.ngb-dp-weekday{width:2rem;height:2rem}[dir] .ngb-dp-day{cursor:pointer}[dir] .ngb-dp-day.disabled,[dir] .ngb-dp-day.hidden{cursor:default}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/main/webapp/stay-mgmt/app/components/custom-datepicker/custom-datepicker-month.component.scss
// module id = ./src/main/webapp/stay-mgmt/app/components/custom-datepicker/custom-datepicker-month.component.scss
// module chunks = 0